import { call, put, select, takeLatest } from "redux-saga/effects";
import iq_api_v2 from "../../../../services/iqApiV2";
//import { FETCH_AUTO_NURTURE_REQUEST, FetchAutoNurtureFailure, FetchAutoNurtureSuccess } from "../../actions/meetingPrep/autoNurtureActions";
import qs from 'qs'
import { FETCH_AUTO_NURTURE_REQUEST, FetchAutoNurtureFailure, FetchAutoNurtureSuccess } from "../../actions/autoNurture/autoNurtureActions";
import iq_auto_nurture_api from "../../../../services/iqAutoNurtureApi";

async function autoNurture(clientName, accountName, userId) {
    try {
      const data = qs.stringify({
        client: clientName,
        account: accountName,
        user_id: userId,
      });
      const response = await iq_auto_nurture_api.get("/campaign/getlist", {
         params: { user_id: userId },
        // responseType: "blob", // Important for binary data
      });
      return response?.data || [];
    } catch (error) {
        console.error('Error:', error.response ? error.response.data : error.message);
    }
  }

// Worker Saga
function* fetchAutoNurtureSaga() {
  try {
    const payload = yield select(
      (state) => state?.autoNurtureReducer?.payload
    );
    const {  clientName,accountName,userId,type } = payload;
    const data = yield call(
        autoNurture,
        clientName,accountName,userId,type
    );
    yield put(FetchAutoNurtureSuccess(data));
  } catch (error) {
    yield put(FetchAutoNurtureFailure(error.message));
  }
}

// Watcher Saga
export function* watchAutoNurtureSaga() {
  yield takeLatest(FETCH_AUTO_NURTURE_REQUEST, fetchAutoNurtureSaga);

}
